module.exports = __webpack_public_path__ + "img/light2.503cea17.png";